import { Redirect, Slot } from 'expo-router';
import { useEffect } from 'react';
import { ActivityIndicator, View } from 'react-native';

import { AppShell } from '@/components/layout/AppShell';
import { NetworkErrorToast } from '@/components/layout/NetworkErrorToast';
import { useSession } from '@/lib/auth/session';
import { SESSION_EXPIRED_EVENT } from '@/lib/net/api-error';
import { getSyncEngine } from '@/lib/sync/engine';
import { SyncStatusBodyAttributes } from '@/lib/sync/sync-status-body';
import { WebSyncProvider } from '@/lib/sync/web-sync-context';

export default function AppLayout() {
  const { data: session, isPending, error } = useSession();

  useEffect(() => {
    console.log('[CS-NET] session', {
      isPending,
      hasSession: Boolean(session),
      error: error?.message ?? null,
    });
  }, [isPending, session, error]);

  useEffect(() => {
    if (!isPending) {
      return;
    }
    const warn = setTimeout(() => {
      console.warn('[CS-NET] session still pending after 10s — auth/get-session may be hung');
    }, 10000);
    return () => clearTimeout(warn);
  }, [isPending]);

  useEffect(() => {
    if (session) {
      void getSyncEngine().start().catch(() => {
        // Sidebar/store surfaces errors; avoid blocking the shell on background sync.
      });
    }
  }, [session]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const onSessionExpired = () => {
      window.location.assign('/login');
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, onSessionExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onSessionExpired);
  }, []);

  if (isPending) {
    return (
      <View className="min-h-full flex-1 items-center justify-center bg-surface">
        <ActivityIndicator size="large" />
      </View>
    );
  }

  if (!session) {
    return <Redirect href="/login" />;
  }

  return (
    <View className="h-full min-h-0 flex-1">
      <WebSyncProvider>
        <SyncStatusBodyAttributes />
        <NetworkErrorToast />
        <AppShell>
          <View className="min-h-0 flex-1">
            <Slot />
          </View>
        </AppShell>
      </WebSyncProvider>
    </View>
  );
}
